export default {"src":"/_next/static/media/yoga_clinics.e375b609.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};